// Client lib imports
const businessEvents = require('client/lib/business-events')
// Client V2 common imports
const routerActions = require('client-v2/common/state/router/actions')

// Action types

const SHOW = 'AUTH_MODAL_SHOW'
const HIDE = 'AUTH_MODAL_HIDE'

// Action creators

function hide() {
  return {
    type: HIDE
  }
}

// Action dispatchers

function show(hasAccount) {
  return async function (dispatch) {
    await businessEvents.trackSegment('auth-login-modal', {
      hasAccount
    })
    dispatch({
      type: SHOW,
      payload: { hasAccount }
    })
  }
}

function showLogin() {
  return show(true)
}

function showSignup() {
  return show(false)
}

function showSULogin() {
  return socialAuth('stumbleupon', true)
}

function sanitizeQueryParams() {
  return function (dispatch, getState) {
    const { pathname } = getState().router.location
    if (pathname === '/login') {
      // Remove error query parameters from login URL
      dispatch(routerActions.replace({ path: '/login' }))
    }
  }
}

function socialAuth(provider, hasAccount) {
  return async function (dispatch, getState) {
    // Wait for tracking before navigating away from page
    await businessEvents.trackSegment('social-auth', {
      authContext: 'login-modal',
      hasAccount,
      provider
    })
    const { pathname, search } = getState().router.location
    const r = encodeURIComponent(pathname + search)
    const href = `/auth/${provider}?r=${r}`
    dispatch(routerActions.navigate({ href }))
  }
}

module.exports = {
  // Action types
  SHOW,
  HIDE,
  // Action creators
  hide,
  // Action dispatchers
  show,
  showLogin,
  showSignup,
  showSULogin,
  sanitizeQueryParams,
  socialAuth
}
